// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__1eiVT","errorContainer":"styles_errorContainer__2WD2S","container":"styles_container__2Yo2v","error":"styles_error__28JVJ"};